import { grey } from '@mui/material/colors';

const Blue900 = '#09213C';
const Blue800 = '#0D315B';
const Blue700 = '#124279';
const Blue600 = '#144A88';
const Blue500 = '#165297';
const Blue400 = '#7397C1';
const Blue300 = '#D0DCEA';
const Blue200 = '#E8EDF3';
const Blue100 = '#F3F6FA';
const Blue050 = '#F9FBFD';
const Orange900 = '#603A01';
const Orange800 = '#905702';
const Orange700 = '#C07402';
const Orange600 = '#D88303';
const Orange500 = '#F09103';
const Orange400 = '#F3A735';
const Orange300 = '#F9D39A';
const Orange200 = '#FCE9CD';
const Orange100 = '#FEF4E6';
const Orange050 = '#FFFFFF';
const Grey900 = '#323232';
const Grey800 = '#5B5B5B';
const Grey700 = '#707070';
const Grey600 = '#848484';
const Grey500 = '#979797';
const Grey400 = '#ABABAB';
const Grey300 = '#BFBFBF';
const Grey200 = '#D3D3D3';
const Grey100 = '#E8E8E8';
const Grey050 = '#F7F7F7';
const White = '#FFFFFF';
const Green700 = '#1B5426';
const Green500 = '#39A749';
const Green050 = '#F6FDF5';
const Red700 = '#6D1C1C';
const Red500 = '#AE2E2E';
const Red050 = '#FFE8E8';

export const colors = {
  background: {
    default: White,
    blue050: Blue050,
    blue200: Blue200,
    grey900: Grey900,
  },
  primary: {
    light: Blue200,
    main: Blue500,
    dark: Blue700,
    contrastText: White,
    900: Blue900,
    800: Blue800,
    700: Blue700, // dark
    600: Blue600,
    500: Blue500, // main
    400: Blue400,
    300: Blue300,
    200: Blue200, // light
    100: Blue100,
    50: Blue050,
  },
  secondary: {
    light: Orange200,
    main: Orange500,
    dark: Orange700,
    contrastText: White,
    900: Orange900,
    800: Orange800,
    700: Orange700, // dark
    600: Orange600,
    500: Orange500, // main
    400: Orange400,
    300: Orange300,
    200: Orange200, // light
    100: Orange100,
    50: Orange050,
  },
  tertiary: {
    light: Blue200,
    main: Blue500,
    dark: Blue700,
    contrastText: White,
    900: Blue900,
    800: Blue800,
    700: Blue700, // dark
    600: Blue600,
    500: Blue500, // main
    400: Blue400,
    300: Blue300,
    200: Blue200, // light
    100: Blue100,
    50: Blue050,
  },
  error: {
    light: Red050,
    main: Red500,
    dark: Red700,
  },
  success: {
    light: Green050,
    main: Green500,
    dark: Green700,
  },
  warning: {
    light: Orange050,
    main: Orange500,
    dark: Orange700,
  },
  info: {
    light: Blue050,
    main: Blue500,
    dark: Blue700,
  },
  text: {
    primary: Grey900,
    secondary: Grey600,
    disabled: Grey400,
    blue: Blue500,
    white: White,
  },
  grey,
  input: {
    background: '#718096',
  },
  shadow: Blue200,
  monochrome: {
    blue050: Blue050,
    blue100: Blue100,
    blue200: Blue200,
    blue300: Blue300,
    blue400: Blue400,
    blue500: Blue500,
    blue600: Blue600,
    blue700: Blue700,
    blue800: Blue800,
    blue900: Blue900,
  },
  neutral: {
    white: White,
    grey050: Grey050,
    grey100: Grey100,
    grey200: Grey200,
    grey300: Grey300,
    grey400: Grey400,
    grey500: Grey500,
    grey600: Grey600,
    grey700: Grey700,
    grey800: Grey800,
    grey900: Grey900,
  },
};
